/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * when the user is presented with an error
 */
export interface ErrorView {
  /**
   * the code of the error
   */
  errorCode: string;
  /**
   * additional reason for the error
   */
  errorReason?: string | null;
  /**
   * information about the action that triggered the error
   */
  errorContext?: string | null;
  /**
   * if the error is triggered by an input - the name of the field the error is associated with
   */
  fieldName?: string | null;
}

export const errorView = (data: Readonly<ErrorView>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'error_view', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/error_view/jsonschema/3-0-1',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
